import { Component, inject } from '@angular/core';
import { AppService, HubService, NotificationService, OrderService, User, UserService } from 'briteatlib';
import { combineLatest, filter, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Order } from 'briteatlib';
import { BadgeModule } from 'primeng/badge';
import { SharedModule } from '../../../modules/shared/shared.module';

@Component({
  selector: 'brt-pending-order-badge',
  standalone: true,
  imports: [SharedModule, BadgeModule],
  templateUrl: './pending-order-badge.component.html',
  styleUrl: './pending-order-badge.component.scss'
})
export class PendingOrderBadgeComponent {
  private notificationService = inject(NotificationService);

  constructor(appService: AppService, userService: UserService, private hubService: HubService,
    private orderService: OrderService) {
    combineLatest([appService.activeBusiness$, userService.current$]).pipe(
      map(args => ({ business: args[0], user: args[1] } as { business: any, user: User })),
      filter(_ => !!_.business && !!_.user),
      takeUntilDestroyed()
    ).subscribe(_ => {
      delete this.pendingOrders;
      if (!_.business.Staffs?.find(s => s.UserId == _.user?.Id && !s.IsDisabled)?.Permissions?.includes('Order')) return;

      this.checkPendingOrders();
      setInterval(() => this.checkPendingOrders(), 5 * 60 * 1000);
      this.hubService.on<Order>('order').subscribe(async () => await this.checkPendingOrders());
    });
    if (appService.isBrowser)
      this.sound = new Audio('/assets/sounds/new-pending-order.mp3');
  }

  sound: any;
  private static ringingInterval: any;
  startRinging() {
    this.stopRinging();
    this.sound?.play();
    PendingOrderBadgeComponent.ringingInterval = setInterval(() => {
      this.sound?.play();
      //notify if window is not visible or minimized
      if (document.hidden || document.visibilityState == 'hidden') {
        this.notificationService.showNotification('New Orders', {
          requireInteraction: true,
          body: `You have ${this.pendingOrders} new orders`,
        }, '/panel/orders');
      }
    }, 30000);
  }

  stopRinging() {
    if (PendingOrderBadgeComponent.ringingInterval)
      clearInterval(PendingOrderBadgeComponent.ringingInterval);
  }


  pendingOrders: number;
  private async checkPendingOrders() {
    this.pendingOrders = await this.orderService.getPendingOrderCount();
    if (this.pendingOrders > 0)
      this.startRinging();
    else this.stopRinging();
  }
}
